// Transcribed verbatim from the client's V2 document, punctuation included: curly quotes
// and apostrophes, the capitalised `Rare Earth Elements` / `Rare Earths`, `$8.5 billion`,
// the UK `defence` a stop away from the US `colors` and `center`, the em dash mid-sentence
// in the Greenland body, and the two titles carrying no full stop (`Rare Earths as a
// Bargaining Chip`, title-cased on its own, and `Welcome to iPhone`). Don't tidy any of it.
//
// Two mechanical concessions, both so the card can render what the prose used to only say:
// the client's Location column is lifted out to `place` (it used to lead the body behind an
// em dash), and each body's trailing citation group to `citations`. A third is local to the
// Ukraine body, which arrives wrapped in the export's own straight quotes — dropped as a
// spreadsheet artefact, not as copy; worth one client confirmation.
export default {
  label: {
    id: 'rm_journey_geopolitical_label',
    defaultMessage: 'Mine its Geopolitical Impact',
  },

  introLabel: {
    id: 'rm_journey_geopolitical_intro_label',
    defaultMessage: 'Intro',
  },
  introTitle: {
    id: 'rm_journey_geopolitical_intro_title',
    defaultMessage: 'The defining metals of our time.',
  },
  introBody: {
    id: 'rm_journey_geopolitical_intro_body',
    defaultMessage:
      'Rare Earth Elements (REE) are a family of 17 metals that give your phone its sharp display, true colors, precise camera, and responsive feel.',
  },
  introBodyTwo: {
    id: 'rm_journey_geopolitical_intro_body_two',
    defaultMessage:
      'But Rare Earths don’t just make our phones work; they shape trade wars, alliances, territorial ambitions, peace negotiations, and global security.',
  },
  introCta: {
    id: 'rm_journey_geopolitical_intro_cta',
    defaultMessage: 'Next',
  },

  greenlandLabel: {
    id: 'rm_journey_geopolitical_greenland_label',
    defaultMessage: 'Greenland',
  },
  greenlandTitle: {
    id: 'rm_journey_geopolitical_greenland_title',
    defaultMessage: 'Rare earths reshape territorial ambitions.',
  },
  greenlandPlace: {
    id: 'rm_journey_geopolitical_greenland_place',
    defaultMessage: 'Nuuk, Greenland',
  },
  greenlandBody: {
    id: 'rm_journey_geopolitical_greenland_body',
    defaultMessage:
      'Beneath the ice lies the reason the island of Greenland commands global attention. Vast mineral resources, including the rare earth minerals that modern technology depends on — and the main reason President Trump says he wants Greenland to become part of the U.S.',
  },
  greenlandCta: {
    id: 'rm_journey_geopolitical_greenland_cta',
    defaultMessage: 'Next',
  },

  chinaLabel: {
    id: 'rm_journey_geopolitical_china_label',
    defaultMessage: 'China',
  },
  chinaTitle: {
    id: 'rm_journey_geopolitical_china_title',
    defaultMessage: 'Rare earths aren’t rare everywhere.',
  },
  chinaPlace: {
    id: 'rm_journey_geopolitical_china_place',
    defaultMessage: 'Beijing, China',
  },
  chinaBody: {
    id: 'rm_journey_geopolitical_china_body',
    defaultMessage:
      'China mines nearly 60% of the world’s rare earths. In April 2025, it imposed export controls on seven elements in response to U.S. tariffs, gaining leverage over cars, chips and defence. Shortages followed within weeks, forcing some companies to pause production.',
  },
  chinaCta: {
    id: 'rm_journey_geopolitical_china_cta',
    defaultMessage: 'Next',
  },

  australiaLabel: {
    id: 'rm_journey_geopolitical_australia_label',
    defaultMessage: 'Australia',
  },
  australiaTitle: {
    id: 'rm_journey_geopolitical_australia_title',
    defaultMessage: 'Rare earths reshape alliances.',
  },
  australiaPlace: {
    id: 'rm_journey_geopolitical_australia_place',
    defaultMessage: 'Canberra, Australia',
  },
  australiaBody: {
    id: 'rm_journey_geopolitical_australia_body',
    defaultMessage:
      'China’s dominance of Rare Earth Elements is creating new webs of geopolitical alliances. The U.S. and Australia struck a deal worth up to $8.5 billion to develop and refine rare earth minerals.',
  },
  australiaCta: {
    id: 'rm_journey_geopolitical_australia_cta',
    defaultMessage: 'Next',
  },

  congoLabel: {
    id: 'rm_journey_geopolitical_congo_label',
    defaultMessage: 'Congo',
  },
  congoTitle: {
    id: 'rm_journey_geopolitical_congo_title',
    defaultMessage: 'Rare earths access is up for negotiation.',
  },
  congoPlace: {
    id: 'rm_journey_geopolitical_congo_place',
    defaultMessage: 'Kinshasa, Democratic Republic of Congo',
  },
  congoBody: {
    id: 'rm_journey_geopolitical_congo_body',
    defaultMessage:
      'The U.S. helped broker a peace deal between Congo and Rwanda, but peace wasn’t the only thing on the table. The negotiations also addressed U.S. access to Congo’s mineral wealth, as Washington seeks to counter China’s dominance of rare earth supply chains, even as fighting continues.',
  },
  congoCta: {
    id: 'rm_journey_geopolitical_congo_cta',
    defaultMessage: 'Next',
  },

  ukraineLabel: {
    id: 'rm_journey_geopolitical_ukraine_label',
    defaultMessage: 'Ukraine',
  },
  ukraineTitle: {
    id: 'rm_journey_geopolitical_ukraine_title',
    defaultMessage: 'Rare Earths as a Bargaining Chip',
  },
  ukrainePlace: {
    id: 'rm_journey_geopolitical_ukraine_place',
    defaultMessage: 'Kyiv, Ukraine',
  },
  ukraineBody: {
    id: 'rm_journey_geopolitical_ukraine_body',
    defaultMessage:
      'Ukraine’s mineral wealth has become part of the war’s geopolitical bargaining. President Trump said he wanted Ukraine to supply the U.S. with rare earth minerals in return for American support.',
  },
  ukraineCta: {
    id: 'rm_journey_geopolitical_ukraine_cta',
    defaultMessage: 'Next',
  },

  saleLabel: {
    id: 'rm_journey_geopolitical_sale_label',
    defaultMessage: 'UK',
  },
  saleTitle: {
    id: 'rm_journey_geopolitical_sale_title',
    defaultMessage: 'Welcome to iPhone',
  },
  salePlace: {
    id: 'rm_journey_geopolitical_sale_place',
    defaultMessage: 'Apple Flagship Store, London, UK',
  },
  saleBody: {
    id: 'rm_journey_geopolitical_sale_body',
    defaultMessage:
      'You buy an iPhone containing rare earth elements at the center of geopolitical tensions, as countries negotiate and compete for control of global supply chains.',
  },
  saleCta: {
    id: 'rm_journey_geopolitical_sale_cta',
    defaultMessage: 'Go deeper on Rare Earths',
  },
} as const
